var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06753 0.727051C4.0546 0.727051 2.41699 2.3527 2.41699 4.35087C2.41699 6.34905 4.0546 7.97469 6.06753 7.97469C8.08045 7.97469 9.7181 6.34905 9.7181 4.35087C9.7181 2.3527 8.08049 0.727051 6.06753 0.727051Z",
    fill: "#20893C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3676 1.24561C14.3594 1.24561 14.351 1.24564 14.3428 1.24568C13.498 1.25223 12.7089 1.58617 12.121 2.18607C11.5433 2.77536 11.2292 3.55278 11.2365 4.37508C11.2437 5.19737 11.5715 5.96982 12.1594 6.55015C12.752 7.13498 13.5369 7.45616 14.3723 7.45616C14.3807 7.45616 14.3891 7.45613 14.3976 7.45609C15.2423 7.44954 16.0314 7.11556 16.6194 6.5157C17.197 5.92641 17.5111 5.14899 17.5039 4.32666C17.4888 2.6226 16.0844 1.24561 14.3676 1.24561Z",
    fill: "#20893C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5207 8.04883H14.2176C12.8059 8.04883 11.5176 8.55133 10.5449 9.37495C10.7883 9.54976 11.0199 9.74031 11.2395 9.94584C11.8871 10.5522 12.3957 11.2588 12.7512 12.0458C13.0715 12.7546 13.2543 13.5014 13.2969 14.2705H19.9996V13.1781C19.9996 10.35 17.5418 8.04883 14.5207 8.04883Z",
    fill: "#20893C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.123 14.271C12.0125 12.6036 11.1097 11.1371 9.76247 10.1972C8.78239 9.51326 7.56677 9.1084 6.24998 9.1084H5.88514C2.63476 9.10844 0 11.5752 0 14.6184V15.2723H12.1347V14.6184C12.1347 14.5017 12.1308 14.3858 12.123 14.271Z",
    fill: "#20893C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGreen);
export default __webpack_public_path__ + "static/media/users-green.4d3622b51899903cf885fb6a221d85da.svg";
export { ForwardRef as ReactComponent };